'use strict';

/**
 * Updates the play/pause button icons based on the video's playback state.
 * Supports various icon class names including infobased-one-*, infobased-two-*, info-two-*, etc.
 *
 * @param {jQuery} $btn - The play button element.
 * @param {boolean} showPlay - Whether to show the play icon (true) or the pause icon (false).
 */
function updateInfoPlayIcons($btn, showPlay) {
    var $playIcon = $btn.find('[class*="playIcon"]');
    var $pauseIcon = $btn.find('[class*="pauseIcon"]');

    if (showPlay) {
        $playIcon.removeClass('d-none');
        $pauseIcon.addClass('d-none');
    } else {
        $playIcon.addClass('d-none');
        $pauseIcon.removeClass('d-none');
    }
}

/**
 * Binds video event listeners for all videos inside any container with specific naming convention.
 * Targeted containers: .infobased-video-content, .infobased-video-section, etc.
 * Selector used: [class*="infobased-video-"]
 */
function bindInfoVideoEvents() {
    $('[class*="infobased-video-"] video').each(function () {
        var $videoElement = $(this);
        $videoElement.off('ended').on('ended', function () {
            var $container = $(this).closest('[class*="infobased-video-"]');
            var $btn = $container.find('.info-play-btn');
            updateInfoPlayIcons($btn, true);
        });
    });
}

// Toggle play/pause on button click
$(document).on('click', '.info-play-btn', function () {
    var $btn = $(this);
    var $container = $btn.closest('[class*="infobased-video-"]');
    var $video = $container.find('video');

    if (!$video.length) return;

    var video = $video.get(0);

    if (video.paused || video.ended) {
        video.play();
        updateInfoPlayIcons($btn, false); // video playing -> show pause icon
    } else {
        video.pause();
        updateInfoPlayIcons($btn, true); // video paused -> show play icon
    }
});

$(document).ready(function () {
    // Initial bindings
    bindInfoVideoEvents();
});

/**
 * Observes the visibility of video elements within info-based containers.
 * Pauses and resets videos (and their play icons) when they are not intersecting.
 */
function observeInfoVideoVisibility() {
    if ('IntersectionObserver' in window) {
        var observerInfo = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                var $container = $(entry.target).closest('[class*="infobased-video-"]');
                var video = $container.find('video').get(0);
                var $btn = $container.find('.info-play-btn');

                if (!video) return;

                // If NOT visible → pause + reset icon
                if (!entry.isIntersecting) {
                    if (!video.paused) {
                        video.pause();
                        updateInfoPlayIcons($btn, true);
                    }
                }
            });
        }, {
            threshold: 0.1 // 10% visibility required to keep possibly playing, else pause
        });

        $('[class*="infobased-video-"] video').each(function () {
            observerInfo.observe(this);
        });
    }
}

$(document).ready(function () {
    observeInfoVideoVisibility();
});
